"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDocSendPositive = function SvgBDocSendPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M105.67 11.686a2.262 2.262 0 01-2.261-2.262V5.73c0-.666-.54-1.206-1.207-1.206H23.688a2.262 2.262 0 110-4.524h78.514a5.737 5.737 0 015.73 5.73v3.694a2.262 2.262 0 01-2.262 2.262zM108.505 121.133A12.704 12.704 0 0195.75 109.5a2.27 2.27 0 014.523-.407 8.255 8.255 0 102.97-7.117 2.265 2.265 0 01-2.887-3.49 12.817 12.817 0 118.135 22.617l.015.03zM59.281 40.267H23.658a2.262 2.262 0 110-4.523h35.623a2.262 2.262 0 010 4.523zM84.229 54.509h-60.57a2.262 2.262 0 110-4.524h60.57a2.262 2.262 0 010 4.524zM84.229 68.758h-60.57a2.262 2.262 0 010-4.523h60.57a2.262 2.262 0 110 4.523zM84.229 83h-60.57a2.262 2.262 0 010-4.524h60.57a2.262 2.262 0 110 4.524zM77.021 97.257H23.658a2.262 2.262 0 110-4.524h53.363a2.262 2.262 0 110 4.524zM77.021 111.49H23.658a2.262 2.262 0 010-4.523h53.363a2.262 2.262 0 010 4.524z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M116.308 36.58a2.262 2.262 0 01-1.606-.663l-9.047-9.047-9.047 9.047a2.263 2.263 0 01-3.204-3.197l10.638-10.683a2.262 2.262 0 013.197 0l10.668 10.683a2.262 2.262 0 01-1.599 3.86z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M105.625 50.89a2.262 2.262 0 01-2.262-2.262V23.636a2.262 2.262 0 114.524 0v24.992a2.262 2.262 0 01-2.262 2.262z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M105.625 86.536a2.262 2.262 0 01-2.262-2.262V62.847a2.262 2.262 0 114.524 0v21.427a2.262 2.262 0 01-2.262 2.262zM136.732 132.842h-20.431a2.262 2.262 0 010-4.524h20.431a2.262 2.262 0 002.262-2.261v-24.02a2.262 2.262 0 114.523 0v24.02a6.785 6.785 0 01-6.785 6.785z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M102.165 143.465H5.73a5.737 5.737 0 01-5.73-5.73V27.239a2.262 2.262 0 012.262-2.261H24.97v-11.98a2.262 2.262 0 014.524 0v14.241a2.262 2.262 0 01-2.262 2.262H4.524v108.234c0 .666.54 1.206 1.206 1.206h96.435c.667 0 1.21-.539 1.213-1.206v-4.893h-21.11a6.785 6.785 0 01-6.785-6.785V95.899a6.785 6.785 0 016.785-6.785h6.59a3.114 3.114 0 001.764-.535l7.954-5.278a7.652 7.652 0 014.282-1.296h11.89a7.667 7.667 0 014.282 1.296l7.931 5.278c.522.35 1.136.537 1.764.535h12.659a2.262 2.262 0 110 4.524h-12.689a7.667 7.667 0 01-4.282-1.297l-7.931-5.278a3.151 3.151 0 00-1.765-.535h-11.889a3.159 3.159 0 00-1.772.535l-7.946 5.278a7.667 7.667 0 01-4.282 1.297h-6.59a2.262 2.262 0 00-2.261 2.261v30.158a2.262 2.262 0 002.261 2.261h23.372a2.262 2.262 0 012.262 2.262v7.155a5.737 5.737 0 01-5.707 5.73z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M137.614 82.932h-7.087a2.262 2.262 0 110-4.524h7.087a2.262 2.262 0 010 4.524zM9.379 18.848a2.262 2.262 0 01-1.598-3.86L22.105.663A2.262 2.262 0 0123.72 0h65.667a2.262 2.262 0 010 4.524H24.653L10.977 18.2c-.426.419-1 .652-1.598.648z",
    fill: "#1B7"
  })));
};

var _default = SvgBDocSendPositive;
exports["default"] = _default;